import './Chip.css'

const Chip = props => {
  const {
    variant = 'default',
    outline = false,
    isOption = false,
    disabled = false,
    children,
    'data-testid': dataTestId,
    className = '',
    ...rest
  } = props
  
  const variantClass = outline ? `chip--${variant}--outlined` : `chip--${variant}`
  const optionClass = isOption ? 'chip--option' : ''
  const classNames = `chip ${variantClass} ${optionClass} ${className}`.trim()
  
  return (
    <div
      className={classNames}
      data-testid={dataTestId}
      {...(disabled && { disabled: true })}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Chip